<template>
    <div class="container-hoverMenu">
        <div class="hoverClass">
            <slot name="hoverItem">
                <img style="width: 14px;" class="iconHover" src="@/assets/IMGS/SVG/info_icon.svg" alt="info">
            </slot>
        </div>
        <div class="container__hoverMenu" ref="hovermenu">
            <label ref="hovertext" class="hoverMenu">
                <slot name="hoverText">Информационный блок</slot>
            </label>
            <span id="hoverback" class="hoverMenu_triangle"/>
        </div> 
    </div>
</template>

<script>
    export default {
        name: 'HoverIcon',
        mounted() {
            var heightForText = `-` + (this.$refs.hovermenu.clientHeight+25) + `px`
            this.$refs.hovermenu.style.marginTop = heightForText;
        },
        data() {
            return {
            }
        }
    }
</script>

<style lang="css" scoped src="@/assets/css/hoverIcon.css"></style>

